import { createSlice, createAction } from "@reduxjs/toolkit";
export const fetchLicenceData = createAction("licence/fetch");
export const deleteLicence = createAction("licence/delete");
export const licenceAdded = createAction("licence/added");
export const licenceUpdated = createAction("licence/updated");

const initialState = {
  formData: {},
  data: [],
  selectedLicences: {},
  deleting: false,
  loading: false,
  error: null,
  success: null,
  total: 0,
  pageCount: 0,
  queryData: {
    filter: {
      status: 1,
    },
    pageIndex: 1,
    pageSize: 10,
  },
};

const licenceSlice = createSlice({
  name: "licences",
  initialState,
  reducers: {
    removeError(state, action) {
      if (action.payload !== undefined) {
        state.success = null;
      } else {
        state.error = null;
      }
    },
    syncFormData(state, action) {
      state.formData = action.payload;
    },
    onFilterSearch(state, action) {
      let filter = action.payload;
      state.queryData = {
        ...state.queryData,
        filter: filter,
        pageIndex: 1,
      };
    },
    pageCountChange(state, action) {
      state.pageCount = action.payload;
    },
    sortByChange(state, action) {
      state.queryData = {
        ...state.queryData,
        sortBy: action.payload,
        pageIndex: 1,
      };
    },
    pageSizeChange(state, action) {
      state.queryData = {
        ...state.queryData,
        pageSize: action.payload,
        pageIndex: 1,
      };
    },
    pageChange(state, action) {
      state.queryData = {
        ...state.queryData,
        pageIndex: action.payload,
      };
    },
    onLicenceSelection(state, action) {
      state.selectedLicences = action.payload;
    },
    updateRowAfterUpdate(state, action) {
      let newItem = action.payload;
      state.data = state.data.map((item) => {
        if (item.id === newItem.id) {
          return { ...item, ...newItem };
        }
        return item;
      });
    },
    initiateResetPassword(state) {
      state.loading = true;
    },
    resetPasswordSuccess(state, action) {
      state.loading = false;
      state.success = action.payload;
    },
    resetPasswordFailed(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    licenceFetchSuccess(state, action) {
      let { pageSize } = state.queryData;
      let { data, total } = action.payload;
      let pageCount = Math.ceil(total / pageSize);
      state.data = data;
      state.total = total;
      state.pageCount = pageCount;
      state.loading = false; 
    },
    licenceFetchFailed(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    deletelicenceSuccess(state, action) {
      let id = action.payload;
      state.data = state.data.filter((item) => item.id !== id);
      state.deleting = false;
    },
    deletelicencePending(state) {
      state.deleting = true;
    },
    deletelicenceFailed(state, action) {
      state.error = action.payload;
      state.deleting = false;
    },
    resetlicenceData(state) {
      state.data = [];
      state.selectedlicences = {};
      state.total = 0;
      state.pageCount = 0;
      state.queryData = {
        filter: {
          status: 1,
        },
        pageIndex: 1,
        pageSize: 10,
      };
    },
  },
});

export const {
  removeError,
  syncFormData,
  onFilterSearch,
  sortByChange,
  pageCountChange,
  pageSizeChange,
  pageChange,
  onLicenceSelection,
  updateRowAfterUpdate,
  initiateResetPassword,
  resetPasswordFailed,
  resetPasswordSuccess,
  licenceFetchSuccess,   
  licenceFetchFailed,
  deleteLicenceFailed,
  deleteLicencePending,
  deleteLicenceSuccess,
  resetLicenceData,
} = licenceSlice.actions;

export default licenceSlice.reducer;
